@if (src) {
  <div style="position: relative;  border-radius: 16px; cursor: pointer;">
    @if (label) {

      <div class="image-label">
        <div style="padding-top: 88px; padding-left: 16px;">
          <div style="min-height: 24px; width: 100%; font-style: italic;">@if (comingSoon) {COMING SOON...}</div>
        {{ label }}</div>
      </div>
    }
    <img class="card" [src]="src">
  </div>
}
